import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { HelperService } from 'src/app/helper.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { ImsService } from '../../ims.service';
import { HostDetailsService } from '../host-details.service';
import { resolveDomainValidationErrorMessage } from 'src/app/shared/domain-validation/domain-validation-messages';
var HOST_PROFILE_TYPE = 'host';
var HostAccountComponent = /** @class */ (function () {
    function HostAccountComponent(imsService, toasterService, hostDetailsService) {
        this.imsService = imsService;
        this.toasterService = toasterService;
        this.hostDetailsService = hostDetailsService;
        this.newEmail = '';
        this.updatingEmail = false;
        this.errorMsg = '';
        this.corporateEmailChecked = false;
        this.corporateEmailDisabled = false;
        this.showEmailDialog = false;
        this.isEmailVerificationInProgress = false;
        this.domainType = '';
        this.domainTypeLookupLoading = false;
        this.domainTypeOptions = ['corporate', 'non_corporate'];
        this.walletBalance = null;
        this.walletBalanceLoading = false;
        this.walletBalanceError = false;
    }
    HostAccountComponent.prototype.ngOnChanges = function (changes) {
        if (changes.data && changes.data.currentValue && changes.data.currentValue.dataFetched === false) {
            this.blankCard();
        }
        else if (changes.data && changes.data.currentValue) {
            this.data = changes.data.currentValue;
            this.constructCard();
            // Set checkbox state based on email only if not in verification process
            if (!this.isEmailVerificationInProgress) {
                var host = this.data.profiles.find(function (profile) { return profile.type === HOST_PROFILE_TYPE; });
                this.corporateEmailChecked = !!(host && host.email);
                this.corporateEmailDisabled = !!(host && host.email);
            }
            if (this.data && this.data.dataFetched === true && this.data.profiles) {
                var hostProfile = this.data.profiles.find(function (profile) { return profile.type === HOST_PROFILE_TYPE; });
                if (hostProfile && hostProfile.id) {
                    this.fetchWalletBalance();
                }
            }
        }
        else {
            this.emptyCard();
        }
    };
    HostAccountComponent.prototype.ngOnInit = function () { };
    HostAccountComponent.prototype.blankCard = function () {
        this.info = {
            header: 'Hopr account',
            dataFetched: false,
            data: []
        };
    };
    HostAccountComponent.prototype.emptyCard = function () {
        this.info = {
            header: 'Hopr account',
            dataFetched: false,
            data: null
        };
    };
    HostAccountComponent.prototype.constructCard = function () {
        if (this.data) {
            var host = this.data.profiles.find(function (profile) { return profile.type === HOST_PROFILE_TYPE; });
            var cardData = [
                {
                    header: 'Current Status',
                    className: host.status === "ACTIVE" ? 'green-badge' : 'red-badge',
                    value: host.status === "ACTIVE" ? 'Active' : 'Inactive',
                    information: !host.status
                }
            ];
            var walletBalanceCardData = HelperService.buildWalletBalanceCardData(this.walletBalance, this.walletBalanceLoading, this.walletBalanceError);
            if (walletBalanceCardData) {
                cardData.push(walletBalanceCardData);
            }
            // Add corporate email checkbox row
            cardData.push({ header: this.corporateEmailLabel, isCheckbox: true });
            // Add email updated by row
            if (host) {
                cardData.push({
                    header: 'Email Updated By',
                    value: host.updatedBy || 'N/A'
                });
            }
            this.info = {
                header: 'Hopr account',
                dataFetched: true,
                data: cardData,
                reload: true
            };
        }
    };
    HostAccountComponent.prototype.formatDate = function (date) {
        return HelperService.dateString(date);
    };
    ;
    // --- Checkbox handler ---
    HostAccountComponent.prototype.onCorporateEmailCheckboxChange = function (event) {
        if (event.target.checked && !this.corporateEmailDisabled) {
            this.isEmailVerificationInProgress = true;
            this.showEmailDialog = true;
            this.newEmail = '';
            this.resetDomainTypeSelection();
            this.errorMsg = '';
        }
    };
    HostAccountComponent.prototype.resetDomainTypeSelection = function () {
        this.domainType = '';
        this.domainTypeLookupLoading = false;
    };
    HostAccountComponent.prototype.canLookupEmail = function () {
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        return trimmedEmail.indexOf('@') > 0;
    };
    HostAccountComponent.prototype.lookupEmailDomain = function () {
        var _this = this;
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        if (!trimmedEmail || trimmedEmail.indexOf('@') <= 0) {
            this.resetDomainTypeSelection();
            return;
        }
        this.domainTypeLookupLoading = true;
        this.imsService.lookupEmailDomain(trimmedEmail).subscribe({
            next: function (response) {
                _this.domainTypeLookupLoading = false;
                if (response && response.exists && response.domainType) {
                    _this.domainType = response.domainType;
                }
                else {
                    _this.domainType = '';
                }
            },
            error: function () {
                _this.domainTypeLookupLoading = false;
                _this.domainType = '';
            }
        });
    };
    // --- Dialog close handler ---
    HostAccountComponent.prototype.closeEmailDialog = function () {
        this.showEmailDialog = false;
        this.isEmailVerificationInProgress = false;
        // Uncheck the box when cancelled
        this.corporateEmailChecked = false;
    };
    // --- Submit email from dialog ---
    HostAccountComponent.prototype.submitEmail = function () {
        var _this = this;
        if (!this.data || !this.data.profiles)
            return;
        var hostProfile = this.data.profiles.find(function (profile) { return profile.type === HOST_PROFILE_TYPE; });
        if (!hostProfile || !this.newEmail) {
            this.errorMsg = 'Please enter a valid email.';
            return;
        }
        if (!this.domainType) {
            this.errorMsg = 'Please select a domain type.';
            return;
        }
        this.updatingEmail = true;
        this.errorMsg = '';
        // Simulate API call for updating email (replace with real service if available)
        this.imsService.updateUserEmail(this.data.id, this.newEmail, ['host'], this.domainType)
            .subscribe({
            next: function (res) {
                _this.showEmailDialog = false;
                _this.isEmailVerificationInProgress = false;
                _this.updatingEmail = false;
                _this.errorMsg = '';
                hostProfile.email = _this.newEmail;
                _this.constructCard();
                _this.corporateEmailChecked = true;
                _this.corporateEmailDisabled = true;
                // Show a success toaster
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Corporate email verified successfully!'
                }));
                window.location.reload();
            },
            error: function (err) {
                _this.updatingEmail = false;
                _this.errorMsg = resolveDomainValidationErrorMessage(err);
                // Don't reset isEmailVerificationInProgress on error, let user try again or cancel
            }
        });
    };
    Object.defineProperty(HostAccountComponent.prototype, "showVerifyEmailToggle", {
        get: function () {
            if (!this.info || !this.info.data)
                return false;
            var emailField = this.info.data.find(function (d) { return d.header === 'Email'; });
            return !emailField || !emailField.value || emailField.value === 'N/A';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostAccountComponent.prototype, "corporateEmailLabel", {
        get: function () {
            if (this.corporateEmailChecked && this.corporateEmailDisabled) {
                return 'Corporate Email (Verified)';
            }
            return 'Corporate Email (Not Verified)';
        },
        enumerable: true,
        configurable: true
    });
    HostAccountComponent.prototype.fetchWalletBalance = function () {
        var _this = this;
        if (!this.data || !this.data.profiles) {
            return;
        }
        var hostProfile = this.data.profiles.find(function (profile) { return profile.type === HOST_PROFILE_TYPE; });
        if (!hostProfile || !hostProfile.id) {
            return;
        }
        this.walletBalanceLoading = true;
        this.walletBalanceError = false;
        this.hostDetailsService.getHostWalletBalance(hostProfile.id).subscribe({
            next: function (response) {
                _this.walletBalanceLoading = false;
                var balance = null;
                if (response && 'balance' in response) {
                    balance = response.balance;
                }
                if (balance !== null && balance !== undefined) {
                    var formattedBalance = parseFloat(balance).toFixed(2);
                    _this.walletBalance = formattedBalance;
                    _this.walletBalanceError = false;
                }
                else {
                    _this.walletBalance = 'Unable to fetch';
                    _this.walletBalanceError = true;
                }
                _this.constructCard();
            },
            error: function (err) {
                _this.walletBalanceLoading = false;
                _this.walletBalanceError = true;
                _this.walletBalance = 'Unable to fetch';
                _this.constructCard();
            }
        });
    };
    HostAccountComponent.prototype.refreshWalletBalance = function () {
        this.walletBalanceError = false;
        this.fetchWalletBalance();
    };
    HostAccountComponent.prototype.onRefresh = function () {
        this.refreshWalletBalance();
    };
    return HostAccountComponent;
}());
export { HostAccountComponent };
